const DATE_AND_TIME_KEYS = [
  'pickup_time_from',
  'pickup_time_to',
  'dropoff_time_from',
  'dropoff_time_to',
];

const TIME_FIELD_PARAMS = {
  from: 'time_from',
  to: 'time_to',
};

const DATE_FIELD_PARAMS = {
  from: 'date_from',
  to: 'date_to',
};

const STOP_TYPES = {
  pickup: 'pickup',
  dropoff: 'dropoff',
  PICKUP: 'PICKUP',
  DROPOFF: 'DROPOFF',
};

const MINUTES_IN_AN_HOUR = 60;

const CONSTANTS_FOR_RULES = {
  MIN_MARGIN_BEFORE_PICKUP_IN_HOURS: 1,
  MIN_MARGIN_BEFORE_DROPOFF_IN_HOURS: 1,
  MAX_STOP_DURATION_IN_HOURS: 24,
  MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS: 7,
  THRESHOLD_TO_CHANGE_DATE_DEFAULTS_IN_HOURS: 7,
  DEFAULT_PICKUP_MARGIN_IN_HOURS: 4,
  MAX_HOUR_TO_CREATE_TODAY: 12,

  STEPS_IN_MINUTES: 30,
  MINUTES_IN_AN_HOUR,
};

export default {
  DATE_AND_TIME_KEYS,

  TIME_FIELD_PARAMS,
  DATE_FIELD_PARAMS,
  STOP_TYPES,

  CONSTANTS_FOR_RULES,
};
